export default {
	$uikit: {
		search: 'search...',
		select: 'select an option',
		itemsSelected: '{count} items select',
		noDataToShow: 'No data to show',
		submit: 'Submit',
		cancel: 'Cancel',
		anErrorAccoutred: 'An error accoutred!',
		connectionError: 'Connection failed',
		file: 'File',
		from: 'From',
		until: 'Until',
		and: 'and',
		hour: '',
		goToToday: 'Go to today',
		now: 'Now',
		changeDate: 'Change date',
		removeAllFilters: 'Remove all filters',
		filter: 'Filter',
		dashboard: 'Dashboard',
		count: 'Count',
		showing: 'Showing {start} - {end} of {total}',
		resultFound: '{count} result found',
		edit: 'Edit',
		saveChanges: 'Save changes',
		save: 'Save',
		currency: {
			IRR: 'IRR',
			IRT: 'IRT'
		},
		prioritizingFilters: 'Prioritizing filters',
		columnCustomization: 'Column customization',
		columnCustomizationDescription:
			'Select and sort the columns you want to display in the table.',
		columnCustomizationMaxColumnInfo:
			'The maximum number of visible columns is {max}',
		columnCustomizationMinColumnInfo:
			'The minimum number of visible columns is {min}',
		operation: 'Operation',
		rowIndex: 'Row',
		noDataToShowBasedOnSelectedFilters:
			'Based on selected filter, no data to show',
		changeFiltersToShowMoreItems: 'Change filters to show more items'
	},
	$validator: {
		invalid: {
			default: 'Input is invalid',
			labeled: '{label} is invalid'
		},
		required: {
			default: 'This field is required',
			labeled: '{label} is required'
		},
		length: {
			default: "Field's value must be exactly {length} characters",
			labeled: "{label}'s value must be exactly {length} characters"
		},
		minLength: {
			default: "Field's value must be at least {length} characters",
			labeled: "{label}'s value must be at least {length} characters"
		},
		maxLength: {
			default: "Field's value must be a maximum of {length} characters",
			labeled: "{label}'s value must be a maximum of {length} characters"
		},
		equalTo: {
			default: "Field's value must be equal to {otherLabel}'s value",
			labeled: "{label}'s value is not equal to {otherLabel}'s value"
		},
		min: {
			default: "Field's value must be greater than or equal to {min}",
			labeled: "{label}'s value must be greater than or equal to {min}"
		},
		max: {
			default: "Field's value must be less than or equal to {max}",
			labeled: "{label}'s value must be less than or equal to {max}"
		},
		persianCharacters: {
			default:
				"Field's value must contain only persian letters without symbols",
			labeled:
				"{label}'s value must contain only persian letters without symbols"
		},
		fileMaxCount: {
			default: 'Can not select more than {maxCount} files',
			labeled: 'Can not select more than {maxCount} files'
		},
		fileMinCount: {
			default: 'At least select {minCount} files',
			labeled: 'At least select {minCount} files'
		},
		fileMaxSize: {
			default: 'The file size must not exceed {maxSize}',
			labeled: 'The file size must not exceed {maxSize}'
		},
		fileType: {
			default: 'Only {types} files are accepted',
			labeled: 'Only {types} files are accepted for {label}'
		}
	}
}
